import axiosInstance from '@/services/axiosInstance'
import Pass from '@/utils/Pass'
import { trim } from 'lodash'
import store from '@/store'

const AUXILIAR_PASS_TYPE = '2'
const COURSE_PASS_TYPE = '4'
const SPORT_PASS_TYPE = '5'

async function listPasses (membership, type = null) {
  const filter = [
    { Field: 'Tipo', Criteria: 'Pase' },
    { Field: 'NumeroSocio', Criteria: membership }
  ]
  if (type) {
    filter.push({ Field: 'TipoCarnet', Criteria: type })
  }
  const data = { filter }
  const req = {
    url: '/rgcc-services/ListaTarjetasWeb/ReadMultiple',
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  const items = res.data?.ReadMultiple_Result?.ListaTarjetasWeb

  const passes = []
  if (items) {
    for (const item of items) {
      const pass = {
        id: item.Id,
        key: item.Key,
        type: item.Tipo,
        description: item.AliasWeb,
        active: item.Activada,
        pending: item.PendienteAprobacion,
        status: Pass.getStatus(item),
        blocked: item.Bloqueada,
        dni: item.DniAcompaniante,
        name: item.NombreApellidosAcompaniante
      }

      const members = [{
        internalNumber: item.No,
        membership: item.NumeroSocio,
        name: item.NombreSocio,
        surname: item.ApellidosSocio,
        image: null
      }]
      if (type !== AUXILIAR_PASS_TYPE) {
        const memberships = item.SocioVinculado ? trim(item.SocioVinculado, '|').split('|') : []
        for (const membership of memberships) {
          if (membership && membership !== item.NumeroSocio) {
            await store.dispatch('users/fetchUser', membership)
            const user = store.getters['users/user'](membership)
            if (user) {
              members.push(user)
            }
          }
        }
      }

      pass.members = members
      passes.push(pass)
    }
  }

  return passes
}

async function listAuxiliarPasses (membership) {
  return await listPasses(membership, AUXILIAR_PASS_TYPE)
}

async function listCoursePasses (membership) {
  return await listPasses(membership, COURSE_PASS_TYPE)
}

async function listSportPasses (membership) {
  return await listPasses(membership, SPORT_PASS_TYPE)
}

export {
  listAuxiliarPasses,
  listCoursePasses,
  listSportPasses
}
